import React, { PureComponent } from 'react'
import MenuToggle from '../../MenuToggle'
import DOTlogo from '../../DOTlogo'
import '../styles/SidebarHeader.css'

class SidebarHeader extends PureComponent {
  render() {
    return (
      <header className="sidebar-header">
        <DOTlogo className="dot_logo" />
        <MenuToggle />
      </header>
    )
  }
}

export default SidebarHeader



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/SidebarHeader/index.jsx